/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Measurement } from './Measurement';
import {
    MeasurementFromJSON,
    MeasurementFromJSONTyped,
    MeasurementToJSON,
    MeasurementToJSONTyped,
} from './Measurement';
import type { LineItem } from './LineItem';
import {
    LineItemFromJSON,
    LineItemFromJSONTyped,
    LineItemToJSON,
    LineItemToJSONTyped,
} from './LineItem';

/**
 * 
 * @export
 * @interface Room
 */
export interface Room {
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    areaName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    roomName: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Room
     */
    tableHeaders?: Array<string> | null;
    /**
     * 
     * @type {Array<Measurement>}
     * @memberof Room
     */
    measurements?: Array<Measurement> | null;
    /**
     * 
     * @type {Array<LineItem>}
     * @memberof Room
     */
    lineItems: Array<LineItem>;
    /**
     * 
     * @type {number}
     * @memberof Room
     */
    roomTotal?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Room
     */
    taxTotal?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Room
     */
    opTotal?: number | null;
}

/**
 * Check if a given object implements the Room interface.
 */
export function instanceOfRoom(value: object): value is Room {
    if (!('roomName' in value) || value['roomName'] === undefined) return false;
    if (!('lineItems' in value) || value['lineItems'] === undefined) return false;
    return true;
}

export function RoomFromJSON(json: any): Room {
    return RoomFromJSONTyped(json, false);
}

export function RoomFromJSONTyped(json: any, ignoreDiscriminator: boolean): Room {
    if (json == null) {
        return json;
    }
    return {
        
        'areaName': json['areaName'] == null ? undefined : json['areaName'],
        'roomName': json['roomName'],
        'tableHeaders': json['tableHeaders'] == null ? undefined : json['tableHeaders'],
        'measurements': json['measurements'] == null ? undefined : ((json['measurements'] as Array<any>).map(MeasurementFromJSON)),
        'lineItems': ((json['lineItems'] as Array<any>).map(LineItemFromJSON)),
        'roomTotal': json['roomTotal'] == null ? undefined : json['roomTotal'],
        'taxTotal': json['taxTotal'] == null ? undefined : json['taxTotal'],
        'opTotal': json['opTotal'] == null ? undefined : json['opTotal'],
    };
}

export function RoomToJSON(json: any): Room {
    return RoomToJSONTyped(json, false);
}

export function RoomToJSONTyped(value?: Room | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'areaName': value['areaName'],
        'roomName': value['roomName'],
        'tableHeaders': value['tableHeaders'],
        'measurements': value['measurements'] == null ? undefined : ((value['measurements'] as Array<any>).map(MeasurementToJSON)),
        'lineItems': ((value['lineItems'] as Array<any>).map(LineItemToJSON)),
        'roomTotal': value['roomTotal'],
        'taxTotal': value['taxTotal'],
        'opTotal': value['opTotal'],
    };
}

